import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { MessageService } from 'src/app/services/message/message.service';

@Component({
  selector: 'app-homes',
  templateUrl: './homes.component.html',
  styleUrls: ['./homes.component.scss']
})
export class HomesComponent implements OnInit {

  loading = true;
  wlc: any;
  name = "";
  showProfilePopup = false;
  profile: string;
  commonRef: string;
  total_projects = 0;
  project_step = 0;

  constructor(private authService: AuthService, private messageService: MessageService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.total_projects = this.messageService.getListProject().length;
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.name = currentUser.givenName;
    if (!currentUser.familyName || currentUser.familyName.trim() === '') {
      this.showProfilePopup = true;
    }
    this.route.paramMap.subscribe(params => {
      this.wlc = params.get('wlc');
    });
    this.authService.endLoading.subscribe((term) =>{ 
      if(term === "1"){
        this.loading = false;
        this.total_projects = this.messageService.getTotalProject();
      }
    });
    this.authService.changeStepProject.subscribe((term) =>{ 
      if(term){
        this.project_step = Number(term);
      }
    });
    if(this.messageService.getListProject().length > 0) {
      
      this.loading = false;
    }
  }

}
